export default "/_next/static/images/addon-plus-8dd41a08e6b0b92cafd7bb3b547c6281.svg";